<template>
    <div>
        <!-- Horizontal layout -->
        <v-row>
            <v-col>
                <template>
                    <v-container class="text-center" fluid>
                        <v-row align="center" justify="center">
                            <v-col cols="4" v-for="(item, index) in value"
                                   :key="index">
                                <v-icon :color="item.color" large>{{getThumb(item)}}</v-icon>
                                <div>{{item.level}}</div>
                                <v-progress-circular :value="item.percentage"
                                                     :color="item.color"
                                                     size="60"
                                                     width="6"
                                                     >
                                    {{item.percentage}}%
                                </v-progress-circular>
                            </v-col>
                           
                        </v-row>
                    </v-container>
                </template>
            </v-col>
        </v-row>

    </div>
</template>

<script>
    import { Chart, ArcElement, Tooltip, Legend, Plugin, PointElement } from 'chart.js'


    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },

        },
        data() {
            return {
                
            }
        },
        mounted() {
            
        },
        computed: {
            getThumb(){
                
                return (item)=>
                {
                var title = ''
                switch(item.id)
                {
                    case 5:
                    title = 'mdi-thumb-up'
                        break

                    case 3:
                    title = 'mdi-thumb-up-outline'
                        break

                    case 1:

                    title = 'mdi-thumb-down'
                        break
                }
                return title

                }
            }
            

        },

        methods: {
        },
    }
</script>

<style scoped>
    
</style>
